import { useQuery } from "@apollo/client";

import {
  geolocatedCurrencyQuery,
  geolocatedCurrencyQueryType,
} from "@zapier/currency";

import { DEFAULT_COUNTRY_CODE } from "@/constants";
import { useAccountCurrency } from "@/hooks";
import { currencyTypeName } from "@/types";

export const useDisplayCurrency = ({
  countryCode = DEFAULT_COUNTRY_CODE,
}: {
  countryCode?: string;
}) => {
  const { currency: accountCurrency, isLoading: isLoadingAccountCurrency } =
    useAccountCurrency();

  const { data, loading: isLoadingGeolocatedCurrency } =
    useQuery<geolocatedCurrencyQueryType>(geolocatedCurrencyQuery, {
      query: geolocatedCurrencyQuery,
      variables: {
        countryCode,
      },
    });

  return {
    displayCurrency: accountCurrency
      ? accountCurrency
      : data?.geolocatedCurrency,
    isLoading: isLoadingAccountCurrency || isLoadingGeolocatedCurrency,
    currencyType: accountCurrency
      ? currencyTypeName.ACCOUNT
      : data?.geolocatedCurrency
      ? currencyTypeName.GEOLOCATED
      : null,
  };
};
